import { http, Result } from "@fider/services/http"
import { PostTargetDate } from "@fider/models"

export const createPostTargetDate = async (name: string, color: string): Promise<Result<PostTargetDate>> => {
  return http.post<PostTargetDate>(`/api/v1/target-dates`, { name, color }).then(http.event("posttargetdate", "create"))
}

export const updatePostTargetDate = async (slug: string, name: string, color: string): Promise<Result<PostTargetDate>> => {
  return http.put<PostTargetDate>(`/api/v1/target-dates/${slug}`, { name, color }).then(http.event("posttargetdate", "update"))
}

export const deletePostTargetDate = async (slug: string, reassignToSlug?: string): Promise<Result> => {
  return http.delete(`/api/v1/target-dates/${slug}`, { reassignToSlug }).then(http.event("posttargetdate", "delete"))
}

export const reorderPostTargetDates = async (orderedSlugs: string[]): Promise<Result> => {
  return http.post(`/api/v1/target-dates/reorder`, { orderedSlugs }).then(http.event("posttargetdate", "reorder"))
}
